// @flow

import React from 'react'
import { Dropdown, Icon } from 'semantic-ui-react'
import { prussian } from 'constants/inlineStyles'

import withMetricClick from '../../../withMetricClick'
import SocialIcon from './SocialIcon'
import type { ModalTypes } from '../../../redux'

let styles = {}

type Props = {
  mapUrl: ?string,
  calendarUrl: ?string,
  openModal: (modalType: ModalTypes) => void
}

const MobileShareDropdown = ({ mapUrl, calendarUrl, openModal }: Props) => {
  const DropdownItemWithShareMetricClick = withMetricClick('share-modal-open')(
    Dropdown.Item
  )
  const DropdownItemWithMapMetricClick = withMetricClick('viewmap')(
    Dropdown.Item
  )
  const DropdownItemWithCalendarMetricClick = withMetricClick('addcal')(
    Dropdown.Item
  )
  
  return (
    <Dropdown
      inline
      icon={<Icon name="ellipsis vertical" size="large" />}
      size="large"
      className="flyer-share-dropdown"
      closeOnChange={false}
      openOnFocus
      style={{ marginRight: '-.25rem' }}
    >
      <Dropdown.Menu>
        <DropdownItemWithShareMetricClick 
          aria-label="flyer share button"
          aria-hidden="false"
          tabIndex={0}
          onClick={() => openModal('share')}
        >
          <div style={{ fontWeight: 'bold', color: prussian }}>
            <Icon
              as="span"
              name="share alternate"
              size="large"
              className="shareModal__trigger"
            />
            <span>Share</span>
          </div>
        </DropdownItemWithShareMetricClick>
        {mapUrl && (
          <DropdownItemWithMapMetricClick>
            <a
              href={mapUrl}
              target="_blank"
              style={styles.socialIconLink}
              className="Social-Icon-Dropdown-Wrapper"
            >
              <SocialIcon
                size="large"
                icon="map outline"
                label="View on a map"
              />
              <span> View Location</span>
            </a>
          </DropdownItemWithMapMetricClick>
        )}
        {calendarUrl && (
          <DropdownItemWithCalendarMetricClick>
            <a
              href={calendarUrl}
              target="_blank"
              style={styles.socialIconLink}
              className="Social-Icon-Dropdown-Wrapper"
            >
              <SocialIcon
                size="large"
                icon="calendar"
                label="Add to calendar"
              />
              <span>Add to Calendar</span>
            </a>
          </DropdownItemWithCalendarMetricClick>
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}

styles = {
  socialIconLink: { textDecoration: 'none' }
}

export default MobileShareDropdown



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailMenu/components/MobileShareDropdown.js